// extracted by mini-css-extract-plugin
export default {"ForumSearch__headline":"pz_a bhi_sl bhi_uy","ForumSearch__img":"pz_b","ForumSearch__searchAdsAndShoppingAds":"pz_c","ForumSearch__results--empty":"pz_e"};